import React, { Component } from 'react';
import Inputc from 'components/Inputc';
import Buttonc from 'components/Buttonc';
import Iconc from 'components/Iconc';
import './index.styl';

const clzpre = 'realname-header';
const Search = Inputc.Search;

class Header extends Component {
    onKeyDown = (e) => {
        if (e.keyCode === 13) {
            this.props.onSearch(e.target.value);
        }
    }

    render() {
        return <header className={clzpre}>
            <Search placeholder='请输入' onKeyDown={this.onKeyDown} />
            <Buttonc><Iconc type='cunchupitchon' />存储</Buttonc>
            <Buttonc><Iconc type='shangchuan' />输出</Buttonc>
        </header>
    }
}

export default Header;